// Simple event emitter for allergen updates
class AllergenEventEmitter {
  constructor() {
    this.listeners = new Map()
  }

  // Subscribe to allergen update events
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set())
    }
    this.listeners.get(event).add(callback)
  }

  // Unsubscribe from allergen update events
  off(event, callback) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback)
    }
  }

  // Emit allergen update event
  emit(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => {
        try {
          callback(data)
        } catch (error) {
          console.error('Error in allergen event callback:', error)
        }
      })
    }
  }

  // Notify all components that allergens have been updated
  notifyAllergenUpdate(type, data) {
    this.emit('allergen-updated', { type, data, timestamp: Date.now() })
  }

  // Notify that product allergens were updated
  notifyProductAllergenUpdate(productId, allergens, allergenTraces) {
    this.notifyAllergenUpdate('product', {
      productId,
      allergens,
      allergenTraces,
    })
  }

  // Notify that custom ingredient allergens were updated
  notifyCustomIngredientAllergenUpdate(
    ingredientId,
    allergens,
    allergenTraces,
  ) {
    this.notifyAllergenUpdate('custom-ingredient', {
      ingredientId,
      allergens,
      allergenTraces,
    })
  }
}

// Create a singleton instance
const allergenEventEmitter = new AllergenEventEmitter()

export default allergenEventEmitter
